export enum locales {
  AU = "AU",
  US = "US",
}
